import { authHeader, authHeaderEmptyContentType } from '@/helpers';
import { handleResponse } from './base.service';
import i18n from '../i18n';

function getAll(search: any) {
  const model = {
    PageNumber: search.actualPage,
    PageSize: search.pageRows,
    OrderBy: search.orderBy,
    OrderByAsc: search.orderByAsc
  };

  Object.keys(search.filter).forEach(key => {
    const filter = search.filter[key];

    if (key !== 'startedOn' && key !== 'endedOn') {
      (model as any)[key] = filter.map((item: any) => item.key);
    }
  });

  if (search.filter.startedOn) {
    (model as any).startedOn = search.filter.startedOn;
  }

  if (search.filter.endedOn) {
    (model as any).endedOn = search.filter.endedOn;
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  return fetch(`/api/ProjectsSimple/Search`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      if (response.headers && response.headers.find((header: any) => header.key === 'x-pagination')) {
        const pagination = JSON.parse(response.headers.find((header: any) => header.key === 'x-pagination').value);
        response.data.totalCount = pagination.TotalCount;
      }

      return response.data;
    });
}

function getById(id: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`/api/ProjectsSimple/${id}`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      localStorage.setItem('projectSimple', JSON.stringify(response.data));

      return response.data;
    });
}

function createProject(project: any) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(project)
  };

  return fetch(`/api/ProjectsSimple`, requestOptions as any)
    .then(handleResponse)
    .then(response => {
      return response.data;
    });
}

function updateProject(id: number, project: any) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(project)
  };

  return fetch(`/api/ProjectsSimple/${id}`, requestOptions as any).then(handleResponse);
}

function deleteProject(id: number) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`/api/ProjectsSimple/${id}`, requestOptions as any).then(handleResponse);
}

function exportTo(search: any, columnsToExport: any) {
  let fileName = 'projects.xlsx';

  const model = {
    PageNumber: search.actualPage,
    PageSize: search.pageRows,
    OrderBy: search.orderBy,
    OrderByAsc: search.orderByAsc,
    CultureCode: i18n.locale === 'en' ? 'en-us' : 'cs-cz'
  };

  if (columnsToExport) {
    (model as any).Columns = columnsToExport.map((column: any) => column.code);
  }

  Object.keys(search.filter).forEach(key => {
    const filter = search.filter[key];

    if (key !== 'startedOn' && key !== 'endedOn') {
      (model as any)[key] = filter.map((item: any) => item.key);
    }
  });

  if (search.filter.startedOn) {
    (model as any).startedOn = search.filter.startedOn;
  }

  if (search.filter.endedOn) {
    (model as any).endedOn = search.filter.endedOn;
  }

  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(model)
  };

  fetch(`/api/ProjectsSimple/Export`, requestOptions as any)
    .then(response => {
      const header = response.headers.get('Content-Disposition') || '';
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(header);

      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }

      return response.blob();
    })
    .then(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.setAttribute('download', fileName);
      a.click();
    });
}

function getLog(projectId: number, search: any) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(
    `/api/ProjectsSimple/${projectId}/history?PageSize=${search.pageRows}&PageNumber=${search.actualPage}&OrderBy=${search.orderBy}&OrderByAsc=${search.orderByAsc}`,
    requestOptions as any
  )
    .then(handleResponse)
    .then(response => {
      if (response.headers && response.headers.find((header: any) => header.key === 'x-pagination')) {
        const pagination = JSON.parse(response.headers.find((header: any) => header.key === 'x-pagination').value);
        response.data.totalCount = pagination.TotalCount;
      }

      return response.data;
    });
}

export const projectSimpleService = {
  getAll,
  getById,
  createProject,
  updateProject,
  exportTo,
  getLog,
  deleteProject
};
